var s = Object.defineProperty;
var a = (t, o, r) => o in t ? s(t, o, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[o] = r;
var i = (t, o, r) => a(t, typeof o != "symbol" ? o + "" : o, r);
import { ErrorWithFields as d } from "./index6.mjs";
import { ErrorWithViolations as c } from "./index7.mjs";
class h extends d {
  toErrorWithViolations() {
    return super.toErrorWithViolations({
      type: "",
      status: e.code,
      title: "",
      code: e.code
    });
  }
}
class e extends c {
}
i(e, "code", 422);
export {
  h as BadRequest,
  e as BadRequestWithViolations
};
